// extracted by mini-css-extract-plugin
export default {"dropdownLabel":"dropdownLabel---gC3ib","dropdownMenu":"dropdownMenu---UP80V"};